<template>
  <div>
    <nav-breadcrumb :menu="[{label: '意向客户'}]"/>
    <el-row>
      <el-col class=" bg-purple">
        <el-tabs v-model="applicationStatus">
          <el-tab-pane label="待审核" name="Pending Approval" />
          <el-tab-pane label="不予授信客户" name="Rejected" />
        </el-tabs>
        <div class="xzpadd10">
          <data-table
            :tableData="listData"
            :columns="applyingCustomerListListColumns"
            :pageSize.sync="pageSize"
            :page.sync="page"
            :filters.sync="filters"
          ></data-table>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import xhr from '../../../utils/xhr'
  import Status2CN from "../../../filters/Status2CN";
  import moment from 'moment'
  import {xmlBuildQuery} from "../../../filters/CommonActions";
  import channelOptions from "../../../utils/channelOptions";

  export default {
    data() {
      return {
        applicationStatus: 'Pending Approval',
        page: 1,
        pageSize: 10,
        listData: {},
        roleData: {},
        filters: {
              form: {
                ix__channel: '',
                c__applicationDate: [],
              },
              columns: [
                {
                  label: '客户渠道',
                  component: 'el-select',
                  field: 'ix__channel',
                  options: channelOptions,
                  span: 10
                },
                {
                  label: '导入日期',
                  component: 'date-range-picker',
                  field: 'c__applicationDate',
                  op: ['gteq', 'lteq'],
                  span: 14
                }
              ],
              onSubmit:()=>{
                this.page = 1
                this.getApplyingCustomerList()
              }
        },
      }
    },
    computed : {
      applyingCustomerListListColumns: function() {
        return [
          {
            name: '客户姓名',
            field: 'c__customerName'
          },
          {
            name: '手机号',
            field: 'i__contactTelNo'
          },
          {
            name: '身份证号码',
            field: 'i__socialIdentityCode'
          },
          {
            name: '获客渠道',
            field: 'ix__channel'
          },
          {
            name: '导入时间',
            field: 'c__applicationDate',
            formatter: function (r,c,v) {
              return moment(v).format('YYYY-MM-DD HH:mm')
            }
          },
          {
            name: '状态',
            field: 'c__applicationStatus',
            formatter: function (r,c,v) {
              return Status2CN(v)
            }
          },
          {
            name: '操作',
            opts: [
              {
                label: '审核&授信(客服)',
                class: 'el-icon-success',
                clickHandler: (index, row) => {
                  this.approveCustomerKF(index, row)
                },
                  conditions: row=> {
                    return row.t__roleId==this.roleData.roleId0&&row.c__applicationStatus=='Pending Approval'

                  }
              },

              {
                label: '审核&授信(风控)',
                class: 'el-icon-success',
                clickHandler: (index, row) => {
                  this.approveCustomer(index, row)
                },
                conditions: row=> {

                  return row.t__roleId==this.roleData.roleId1&&row.c__applicationStatus=='Pending Approval'
                }
              },
              {
                label: '审核&授信(总经理)',
                class: 'el-icon-success',
                clickHandler: (index, row) => {
                  this.approveCustomerZJL(index, row)
                },
                conditions: row=> {
                  return row.t__roleId==this.roleData.roleId2&&row.c__applicationStatus=='Pending Approval'
                }
              },
              {
                label: '审核&授信(董事长)',
                class: 'el-icon-success',
                clickHandler: (index, row) => {
                  this.approveCustomerDSZ(index, row)
                },
                conditions: row=> {
                  return row.t__roleId==this.roleData.roleId3&&row.c__applicationStatus=='Pending Approval'
                }
              },
              /*{
                label: '审核&授信(终审)',
                class: 'el-icon-success',
                clickHandler: (index, row) => {
                  this.approveCustomerZS(index, row)
                },
                conditions: row=> {
                  let ret = false, roles = this.$store.state.userInfo.detail
                  ret = row.c__applicationStatus=='Pending Approval'&&row.c__roleId=='LJME2JBG010T'
                  if(ret){
                    for(var i=0;i<roles.length;i++){
                      if('LJME2JBG010T'==roles[i].r__roleId){
                        return ret
                      }
                    }
                    return false
                  }else{
                    return ret
                  }
                }
              },*/

              {
                label: '查看详情',
                class: 'el-icon-info',
                clickHandler: (index, row) => {
                  this.viewDetail(index, row)
                },
              },
            ]
          }
        ]
      },

      filterParams: {
        get: function() {
          return {
            pageSize: this.pageSize,
            pageOffset: (this.page - 1) * this.pageSize,
            'xlist.search.c.applicationStatus' : this.applicationStatus,
            'xlist.search.c.applicationStatus.op' : 'in',
            'xlist.sort.dataField': 'c.applicationDate',
            'xlist.sort.order': 'desc'
          }
        },
        set:function (newVal) {

        }
      }
    },
    watch: {
      filterParams: function () {
        this.getApplyingCustomerList()
      },
    },
    mounted() {
      this.getApplyingCustomerList()
    },
    methods: {
      getApplyingCustomerList: function () {
        xhr.getApplyingCustomerList(
          Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
          res => {
            try {
              this.listData = res.data
              this.roleData = res.data.variables
            } catch (e) {

            }
          })
      },
      viewDetail: function (index, row) {
        try{
          let cr__creditId = row.cr__creditId||''
          this.$router.push({
            path: 'Detail?c.applicationId='+row.c__applicationId+'&cr.creditId='+cr__creditId
          })
        }catch (e) {

        }
      },
      approveCustomer: function (index, row) {
        this.$router.push({
          name: 'CustomerApplyingCustomerApprove',
          query: {
            'c.applicationId' : row.c__applicationId,
            'cr.creditId':row.cr__creditId||''
          }
        })
        // this.$confirm('确认审核该用户？', '提示', {
        //   confirmButtonText: '确定',
        //   cancelButtonText: '取消',
        //   type: 'warning'
        // }).then(() => {
        //   xhr.updateApproveCustomer({
        //     "c.applicationId": row.c__applicationId,
        //     "a.approvingStatus": 'Approved',
        //     "a.remarks": ""
        //   }, res=>{
        //     try{
        //       if(res.data.status == 'success') {
        //         this.$message({
        //           type: 'success',
        //           message: '操作成功!'
        //         });
        //         this.getApplyingCustomerList()
        //       }
        //     }catch (e) {
        //     }
        //   })
        // }).catch(() => {
        //   this.$message({
        //     type: 'info',
        //     message: '已取消操作'
        //   });
        // });
      },
      approveCustomerKF: function (index, row) {
        this.$router.push({
          name: 'CustomerApplyingCustomerApproveKF',
          query: {
            'c.applicationId': row.c__applicationId,
            'cr.creditId': row.cr__creditId || ''
          }
        })
      },
      approveCustomerZJL: function (index, row) {
        this.$router.push({
          name: 'CustomerApplyingCustomerApproveZJL',
          query: {
            'c.applicationId': row.c__applicationId,
            'cr.creditId': row.cr__creditId || ''
          }
        })
      },
      approveCustomerDSZ: function (index, row) {
        this.$router.push({
          name: 'CustomerApplyingCustomerApproveDSZ',
          query: {
            'c.applicationId': row.c__applicationId,
            'cr.creditId': row.cr__creditId || ''
          }
        })
      },
      approveCustomerZS: function (index, row) {
        this.$router.push({
          name: 'CustomerApplyingCustomerApproveZS',
          query: {
            'c.applicationId': row.c__applicationId,
            'cr.creditId': row.cr__creditId || ''
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/CustomerAdmin/CustomerApplyingList.vue